module.exports = __webpack_public_path__ + "img/segunda_opcion.ecf5e0aa.svg";